<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" routerLink="/">
        <img
            alt="logo"
            src="../../../assets/logo.svg"
            height="30"
            width="203"
        />
    </a>
    <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup"
        aria-expanded="false"
        aria-label="Toggle navigation"
    >
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <ul class="navbar-nav">
            <li routerLinkActive="active" *ngIf="showProjects">
                <a
                    class="nav-item nav-link"
                    routerLink="/projects"
                    >Shipping</a
                >
            </li>
            <li routerLinkActive="active" *ngIf="showStorage">
                <a
                    class="nav-item nav-link"
                    routerLink="/storage"
                    >Storage</a
                >
            </li>
            <li routerLinkActive="active" *ngIf="showSustainability">
                <a
                    class="nav-item nav-link"
                    routerLink="/sustainability"
                    >Sustainability</a
                >
            </li>
            <li routerLinkActive="active" *ngIf="showTerminal">
                <a
                    class="nav-item nav-link"
                    routerLink="/terminal"
                    >Terminal</a
                >
            </li>
            <li routerLinkActive="active" *ngIf="showUsers">
                <a
                    class="nav-item nav-link"
                    routerLink="/users"
                    >Users</a
                >
            </li>
        </ul>
    </div>
    <div class="navbar-nav">
        <a
            class="nav-link btn btn-outline-primary support-link"
            (click)="openSupport()"
            >Support</a
        >
        <a class="nav-link" (click)="logout()">Log out</a>
    </div>
</nav>
